




import Vue from 'vue';
import OfficialDocumentAdd from '@/components/official-documents/official-document-add.component.vue';

export default Vue.extend({
  components: {
    'official-document-add': OfficialDocumentAdd,
  },
});
